import { connect } from 'react-redux';
import MenuContent from '../../../components/navbar/MenuContent';
import { profile } from 'core/selectors';

export default connect(
  state => ({
    profile: profile(state),
  }),
  {},
)(MenuContent); 